export const isPhoneNumber = (phone) => {
    return (/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone))
}
  
/**
 * 获取当前定位
 *  //关于状态码
 //BMAP_STATUS_SUCCESS  检索成功。对应数值“0”。
 //BMAP_STATUS_CITY_LIST  城市列表。对应数值“1”。
 //BMAP_STATUS_UNKNOWN_LOCATION  位置结果未知。对应数值“2”。
 //BMAP_STATUS_UNKNOWN_ROUTE  导航结果未知。对应数值“3”。
 //BMAP_STATUS_INVALID_KEY  非法密钥。对应数值“4”。
 //BMAP_STATUS_INVALID_REQUEST  非法请求。对应数值“5”。
 //BMAP_STATUS_PERMISSION_DENIED  没有权限。对应数值“6”。(自 1.1 新增)
 //BMAP_STATUS_SERVICE_UNAVAILABLE  服务不可用。对应数值“7”。(自 1.1 新增)
 //BMAP_STATUS_TIMEOUT  超时。对应数值“8”。(自 1.1 新增)
 * @returns {Promise<unknown>}
 */
// 获取定位 基于百度地图
// 获取经纬度
export const getLocation = () => {
    return new Promise((resolve, reject) => {
        if (!window.BMap) {
            reject()
        }
        const geolocation = new window.BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() === window.BMAP_STATUS_SUCCESS) {
                resolve(r.point)
            } else {
                reject('failed' + this.getStatus())
            }
        })
    })
}
// 获取当前地址
export const getAddress = () => {
    return new Promise((resolve, reject) => {
        if (!window.BMap) {
            reject()
        }
        const geolocation = new window.BMap.Geolocation();
        geolocation.getCurrentPosition(function (r) {
            if (this.getStatus() === window.BMAP_STATUS_SUCCESS) {
                const myGeo = new window.BMap.Geocoder()
                    myGeo.getLocation(new window.BMap.Point(r.point.lng, r.point.lat), data => {
                    if (data.addressComponents) {
                    const result = data.addressComponents
                    console.log(data.addressComponents);
                    const location = {
                        creditLongitude: r.point.lat, // 经度
                        creditLatitude: r.point.lng, // 纬度
                        creditProvince: result.province || '', // 省
                        creditCity: result.city || '', // 市
                        creditArea: result.district || '', // 区
                        creditStreet: (result.street || '') + (result.streetNumber || '') // 街道
                    }
                    console.log(location);
                    resolve(location)
                    // alert(this.getStatus());
                    }
                })
            } else {
                reject('failed' + this.getStatus())
            }
        })
        
    })
}


//时间转化 YYYY-MM-DD hh:mm:ss
export function parseTimeS(time) {
    if (time) {
        var date = new Date(time);
        var year = date.getFullYear();
        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    } else {
        return ''
    }
}
//时间转化 YYYY-MM-DD
export function parseTimeD(time) {
    if (time) {
        // 拼接
        if(typeof(time) == 'string'){
            return time.split(' ')[0];
        }else{
            var date = new Date(time);
            var year = date.getFullYear();
            var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            return year + '-' + month + '-' + day;
        }
    } else {
        return ''
    }
}
export function parseTimeZ(time) {
    if (time) {
        // var date = new Date(time);
       
        // var year = date.getFullYear();
        // var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
        // var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        
        let date = time.split(' ')[0];
        let timeList = date.split('-');
        // 拼接
        return timeList[0] + '年' + timeList[1] + '月' + timeList[2] + '日';
    } else {
        return ''
    }
}

//时间转化 hh:mm:ss
export function parseTimeHMS(time) {
    if (time) {
        // var date = new Date(time);
        // var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        // var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        // var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        let date = time.split(' ')[1];
        let timeList = date.split(':');
        // 拼接
        return timeList[0] + ':' + timeList[1] + ':' + timeList[2];
    } else {
        return ''
    }
}

// 密码中必须包含字母（不区分大小写）、数字，至少8个字符
export function pwdRegex(str) {
    var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
    if(!pwdRegex.test(str)) {
        return false;
    }else{
        return true;
    }
}

export function hidePhone(phone){
    let tel = phone;
    let reg = /^(\d{3})\d{4}(\d{4})$/;
    tel = tel.replace(reg, "$1****$2");
    return tel;
}
